export enum DevelopmentDirectorate {
  OTHER = 'OTHER',
  AUSTRALIA = 'AUSTRALIA',
  FRANCE = 'FRANCE',
  GERMANY_OTHER = 'GERMANY_OTHER',
  EUROPE = 'EUROPE',
  UK = 'UK',
}
export const devDirectorateToLabel: {[value: string]: string} = {
  [DevelopmentDirectorate.OTHER]: 'Not within a defined Development Directorate',
  [DevelopmentDirectorate.AUSTRALIA]: 'Development Australia',
  [DevelopmentDirectorate.FRANCE]: 'Development France',
  [DevelopmentDirectorate.GERMANY_OTHER]: 'Development Germany',
  [DevelopmentDirectorate.EUROPE]: 'Development Europe',
  [DevelopmentDirectorate.UK]: 'Development UK',
};
